import React from 'react'
import styled from 'styled-components'

/**
 * 块的 footer
 *
 * @param param0 - 参数
 * @param param0.left - 左侧内容
 * @param param0.right - 右侧内容
 * @param param0.className - 类名
 * @returns 组件
 */
export const BlockFooter: React.FC<{
  left: React.ReactNode
  right: React.ReactNode
  className?: string
}> = ({ left, right, className }) => (
  <Footer className={className}>
    {left}
    {right}
  </Footer>
)

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 4px 4px;
  padding: 8px 16px;
  background-color: ${(props) => props.theme.background._4};
`

export const LeftLabel = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.text._3};
`
